import styles from './LoadingMainContent.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const LoadingMainContent = () => {
  return (
    <div className={cx("loading-container")}>
      <div className={cx("loading-spinner")}>
        {[...Array(12)].map((_, i) => (
          <div key={i} className={cx("loading-dot")}></div>
        ))}
      </div>
      <p className={cx("loading-text")}>Loading...</p>
    </div>
  );
};

export default LoadingMainContent;
